// Attach this to a switch input to give it a class when its been focused
export function CoreSwitchDirective (){
  return {
    restrict: 'A',
    link ( scope, element ) {
      function handleBlur () {
        element.parent()
        .find('.switch-label')
        .removeClass('switch-has-focus');
      }

      function handleFocus () {
        element.parent()
        .find('.switch-label')
        .addClass('switch-has-focus');
      }

      element.on('blur', handleBlur);
      element.on('focus', handleFocus);

      scope.$on('$destroy', () => {
        element.off('blur', handleBlur);
        element.off('focus', handleFocus);
      });
    }
  };
}